import { render, staticRenderFns } from "./DiscountSingleSettings.vue?vue&type=template&id=355588d4&scoped=true&"
import script from "./DiscountSingleSettings.vue?vue&type=script&lang=js&"
export * from "./DiscountSingleSettings.vue?vue&type=script&lang=js&"
import style0 from "./DiscountSingleSettings.vue?vue&type=style&index=0&id=355588d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355588d4",
  null
  
)

export default component.exports